<mat-form-field class="flex-auto gt-xs:pr-3 w-full" (click)="edit()" (focus)="edit()">
  <mat-label *ngIf="labelField"> {{ labelField }}</mat-label>
  <div [matTooltip]="showTip" class="w-full">
    @if (hasNestedFiltersOn) {
      <mat-select
        (selectionChange)="onSelectionChange()"
        [(ngModel)]="value"
        (blur)="onBlur()"
        disableOptionCentering
        #select
      >
        <mat-form-field class="sticky top-0 z-10 w-full p-2 pb-0">
          <input matInput [(ngModel)]="searchTxt" placeholder="Search..." autocomplete="off" />
        </mat-form-field>
        @if (enableEmptyField) {
          <mat-option [value]="emptyFieldDef.name">{{ emptyFieldDef.label }}</mat-option>
        }
        <mat-optgroup
          *ngFor="let group of filteredOptions | groupBy: '_parentFieldName' : '_parentFieldLabel'"
          [label]="group.groupLabel || (group.items[0].related_to_type | relatedToTypeTitle: [])"
          [disabled]="false"
        >
          <mat-option
            *ngFor="let item of group.items"
            [value]="item.name"
            [class.display-none]="item.exclude_in_nested_filter || item.exclude_in_nested_fields"
          >
            {{ item.label }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    } @else {
      <mat-select
        (selectionChange)="onSelectionChange()"
        [(ngModel)]="value"
        (blur)="onBlur()"
        disableOptionCentering
        #select
      >
        <mat-form-field class="sticky top-0 z-10 w-full p-2 pb-0">
          <input matInput [(ngModel)]="searchTxt" placeholder="Search..." autocomplete="off" />
        </mat-form-field>
        <mat-option
          *ngFor="let option of filteredOptions | fieldSearch: searchTxt; let first = first"
          [value]="option.name"
          >{{ option.label }}</mat-option
        >
      </mat-select>
    }
  </div>
</mat-form-field>
